import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { colors } from '../constants';

interface OptionalTextInputProps {
  actionText: string;
  show?: boolean;
  children: React.ReactNode;
}

const Visible = styled.div`
  width: 100%;
`;
Visible.displayName = 'Visible';

const Hidden = styled.div`
  width: 100%;
`;
Hidden.displayName = 'Hidden';

// TODO: add focus indicator
const ShowFieldActionText = styled.button`
  height: 2rem;
  border-radius: 2rem;
  border: 0.0625rem solid transparent;
  font-weight: 400;
  font-size: 1rem;
  text-decoration: underline;
  appearance: none;
  background-color: transparent;
  color: ${colors.TEXT_ACTION};
  cursor: pointer;
`;
ShowFieldActionText.displayName = 'ShowFieldActionText';

export const OptionalTextInput: FC<OptionalTextInputProps> = ({
  actionText,
  show = false,
  children,
}) => {
  const [visible, setVisible] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Treat enter or space key press like a mouse click
    if (e.key === 'Enter' || e.key === 'Space' || e.code === 'Space') {
      e.preventDefault();
      setVisible(!visible);
    }
  };

  if (visible || show) {
    return <Visible>{children}</Visible>;
  }
  return (
    <Hidden>
      <ShowFieldActionText
        id="optionalTextInput"
        type="button"
        onMouseDown={() => setVisible(!visible)}
        onKeyDown={(e) => handleKeyDown(e)}
      >
        {actionText}
      </ShowFieldActionText>
    </Hidden>
  );
};
